export const INDUSTRIES = [
  "IT & Technology",
  "BFSI & Fintech",
  "Healthcare & Life Sciences",
  "Retail & E-commerce",
  "Manufacturing & Engineering",
  "BPO & KPO",
  "Real Estate",
  "Startups & GCCs",
];

export const JOB_TYPES = ["Full-time", "Contract", "Remote", "Part-time", "Internship"];

export const APPLICATION_STATUSES = ["new", "reviewed", "shortlisted", "interview", "offer", "hired", "rejected"];

export const KANBAN_STAGES = [
  { id: "new", label: "New" },
  { id: "reviewed", label: "Reviewed" },
  { id: "shortlisted", label: "Shortlisted" },
  { id: "interview", label: "Interview" },
  { id: "offer", label: "Offer" },
  { id: "hired", label: "Hired" },
  { id: "rejected", label: "Rejected" },
];

export const STATUS_STYLES = {
  new: "border-sky-400/40 text-sky-300",
  reviewed: "border-amber-400/40 text-amber-300",
  shortlisted: "border-emerald-400/40 text-emerald-300",
  interview: "border-violet-400/40 text-violet-300",
  offer: "border-cyan-400/40 text-cyan-300",
  hired: "border-brand/50 text-brand-soft",
  rejected: "border-rose-400/40 text-rose-300",
  open: "border-emerald-400/40 text-emerald-300",
  closed: "border-white/20 text-slate-400",
};

export const COMPANY_STATUSES = ["lead", "active", "past"];

export const COMPANY_STATUS_STYLES = {
  lead: "border-amber-400/40 text-amber-300",
  active: "border-emerald-400/40 text-emerald-300",
  past: "border-white/20 text-slate-400",
};

export const DEAL_STAGES = ["new", "negotiation", "won", "lost"];

export const DEAL_STAGE_STYLES = {
  new: "border-sky-400/40 text-sky-300",
  negotiation: "border-amber-400/40 text-amber-300",
  won: "border-emerald-400/40 text-emerald-300",
  lost: "border-rose-400/40 text-rose-300",
};

// Light-theme variants for the admin workspace (recruitly.io / giighire.com inspired SaaS shell)
export const INPUT_LIGHT = "bg-white border-slate-200 text-slate-800 placeholder:text-slate-400 focus-visible:ring-brand";
export const SELECT_CONTENT_LIGHT = "bg-white border-slate-200 text-slate-800";

export const STATUS_STYLES_LIGHT = {
  new: "border-sky-200 bg-sky-50 text-sky-700",
  reviewed: "border-amber-200 bg-amber-50 text-amber-700",
  shortlisted: "border-emerald-200 bg-emerald-50 text-emerald-700",
  interview: "border-violet-200 bg-violet-50 text-violet-700",
  offer: "border-cyan-200 bg-cyan-50 text-cyan-700",
  hired: "border-orange-200 bg-orange-50 text-brand",
  rejected: "border-rose-200 bg-rose-50 text-rose-600",
  open: "border-emerald-200 bg-emerald-50 text-emerald-700",
  closed: "border-slate-200 bg-slate-100 text-slate-500",
};

export const COMPANY_STATUS_STYLES_LIGHT = {
  lead: "border-amber-200 bg-amber-50 text-amber-700",
  active: "border-emerald-200 bg-emerald-50 text-emerald-700",
  past: "border-slate-200 bg-slate-100 text-slate-500",
};

export const DEAL_STAGE_STYLES_LIGHT = {
  new: "border-sky-200 bg-sky-50 text-sky-700",
  negotiation: "border-amber-200 bg-amber-50 text-amber-700",
  won: "border-emerald-200 bg-emerald-50 text-emerald-700",
  lost: "border-rose-200 bg-rose-50 text-rose-600",
};

export const STAGE_DOTS = {
  new: "bg-sky-500",
  reviewed: "bg-amber-500",
  shortlisted: "bg-emerald-500",
  interview: "bg-violet-500",
  offer: "bg-cyan-500",
  hired: "bg-brand",
  rejected: "bg-rose-500",
};

export const STAGE_ACTIVE_STYLES = {
  new: "border-sky-500 bg-sky-500 text-white",
  reviewed: "border-amber-500 bg-amber-500 text-white",
  shortlisted: "border-emerald-500 bg-emerald-500 text-white",
  interview: "border-violet-500 bg-violet-500 text-white",
  offer: "border-cyan-500 bg-cyan-500 text-white",
  hired: "border-brand bg-brand text-white",
  rejected: "border-rose-500 bg-rose-500 text-white",
};

const AVATAR_TONES = [
  "bg-orange-100 text-orange-600",
  "bg-sky-100 text-sky-600",
  "bg-emerald-100 text-emerald-600",
  "bg-violet-100 text-violet-600",
  "bg-rose-100 text-rose-600",
  "bg-cyan-100 text-cyan-600",
];

export const avatarTone = (name = "") =>
  AVATAR_TONES[(name.charCodeAt(0) + name.length) % AVATAR_TONES.length];

export const initialsOf = (name = "") =>
  name.split(" ").filter(Boolean).map((w) => w[0]).slice(0, 2).join("").toUpperCase();

export const formatINR = (v) => {
  const n = Number(v) || 0;
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(1)} Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(1)} L`;
  if (n >= 1000) return `₹${(n / 1000).toFixed(0)}k`;
  return `₹${n}`;
};

export const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return "";
  }
};

export const fmtDateTime = (iso) => {
  try {
    return new Date(iso).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" });
  } catch {
    return iso || "";
  }
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1567943183748-3a7542120c90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMG1vZGVybiUyMGFyY2hpdGVjdHVyZSUyMGJ1aWxkaW5nfGVufDB8fHx8MTc4Nzg0MjgyN3ww&ixlib=rb-4.1.0&q=85",
  team: "https://images.unsplash.com/photo-1758691736975-9f7f643d178e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjB0ZWFtJTIwbW9kZXJuJTIwb2ZmaWNlfGVufDB8fHx8MTc4Nzg0MjgxNXww&ixlib=rb-4.1.0&q=85",
  office: "https://images.unsplash.com/photo-1560264280-88b68371db39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjB0ZWFtJTIwbW9kZXJuJTIwb2ZmaWNlfGVufDB8fHx8MTc4Nzg0MjgxNXww&ixlib=rb-4.1.0&q=85",
  candidate: "https://images.unsplash.com/photo-1573497620053-ea5300f94f21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxjYW5kaWRhdGUlMjBqb2IlMjBpbnRlcnZpZXd8ZW58MHx8fHwxNzg3ODQyODE1fDA&ixlib=rb-4.1.0&q=85",
};
